module.exports = __webpack_public_path__ + "img/lock-unlocked.f174c12d.svg";